<template>
   <div class="container-fluid">
      <div class="row bt-1">
         您已經成功完成訂購，謝謝<br />
         <b>[單號:{{ order_no }}]</b> <br />
         訂購明細如下:<br /><br />
      </div>
      <div class="row">
         <div class="col-md-12">
            <table class="table">
               <thead>
                  <tr>
                     <th>產品名稱</th>
                     <th>數量</th>
                  </tr>
               </thead>
               <tbody>
                  <tr v-for="item in cart.cartItems" :key="item.suuid">
                     <td>
                        {{ item.product_name }}
                     </td>
                     <td>
                        {{ item.qty }}
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
      <div class="row bt-1">訂單若要修改請來電喔 (02)2592-7857</div><br>
      <div class="row">
         <button type="button" class="btn btn-primary" @click="redirect2Main()">
            繼續訂購
         </button>
      </div>
   </div>

   <!-- <div class="container">
         <p class="mt-1 mb-1 text-muted">
           您已經成功完成訂購，謝謝<br>訂購單號為{{order_no}}<hr>
           雙水栓灣頭13X1/2(加長):2000只<br>
           T13  : 10只<br><hr>
         訂單若要修改請來電喔<br>(02)2592-7857<br><br>

                  <b>可以至上方選擇【產品分類】繼續選擇產品訂購</b><br>
         </p>
   </div> -->
</template>

<script>
export default {
   name: "Success",
   data() {
      return {
         order_no: "",
         cart: {},
      };
   },
   methods: {
      redirect2Main() {
         this.$router.push(`/customer/customer_order/`);
      },
   },
   created() {
      this.order_no = this.$route.query.order_no;
      this.cart = JSON.parse(localStorage.getItem("cart"));
      // console.log("cart:", this.cart);
   },
};
</script>

<style scoped>
html,
body {
   height: 100%;
}

body {
   display: -ms-flexbox;
   display: flex;
   -ms-flex-align: center;
   align-items: center;
   padding-top: 40px;
   padding-bottom: 40px;
   background-color: #f5f5f5;
}

.form-signin {
   width: 100%;
   max-width: 330px;
   padding: 15px;
   margin: auto;
}
.form-signin .checkbox {
   font-weight: 400;
}
.form-signin .form-control {
   position: relative;
   box-sizing: border-box;
   height: auto;
   padding: 10px;
   font-size: 16px;
}
.form-signin .form-control:focus {
   z-index: 2;
}
.form-signin input[type="email"] {
   margin-bottom: -1px;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
   margin-bottom: 10px;
   border-top-left-radius: 0;
   border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/OrderSuccess.vue